<template>
  <section>
    <div class="mt-4">
      <h1 class="text-gray-500 text-md mb-2">
        A tick adds some space between narrative elements. Each tick represents
        about
        <span class="text-blue-400">10% of vertical screen size</span>. How many
        ticks do you want to add?
      </h1>

      <label
        for="number-ticks"
        class="block text-sm leading-5 font-medium text-gray-700 mb-2"
        >Number of ticks</label
      >
      <v-select v-model="element.number" :options="numberTicks"></v-select>
    </div>
  </section>
</template>

<script>
// import Component from "../component_location"

export default {
  components: {},

  props: ["element"],

  data() {
    return {
      numberTicks: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    };
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {},
};
</script>

<style></style>
